module.exports = __webpack_public_path__ + "static/img/lanbar.fe57ae00.png";